module.exports = __webpack_public_path__ + "adb7237e9be95b0aef3269809746cf92.svg";